/*
 * 需求管理接口
 * */
import services from "../config/axios";
import base from "./base";

const newRequireManageAPI = {
    // 获取需求列表
    getRequireList<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetRequiresList`, params);
    },
    getRequireListAdvance<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewRequire/GetRequiresListAdvance`,
            params
        );
    },
    //获取一个需求
    getRequireOne<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetRequiresOne`, params);
    },
    //保存需求
    addRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AddRequires`, params);
    },
    //更新需求
    updateRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/UpdateRequires`, params);
    },
    //更新需求
    updateRequiresAdmin<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewRequire/UpdateRequiresAdmin`,
            params
        );
    },
    //删除需求
    deleteRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/DeleteRequires`, params);
    },
    //提交需求
    submitRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/SubmitRequires`, params);
    },
    // 获取需求审核列表
    getAuditList<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetAuditList`, params);
    },
    // 获取需求审核数量
    getAuditNum<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetAuditNum`, params);
    },
    // 插入审核记录
    addAuditRecord<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AddAuditRecord`, params);
    },
    // 获取审核记录列表
    getAuditRecordList<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewRequire/GetAuditRecordList`,
            params
        );
    },
    // 审核需求
    auditRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AuditRequires`, params);
    },
    // 审核RPA流程退役
    auditRPARetire<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AuditRPARetire`, params);
    },
    // 审核RPA流程添加业务人员
    auditRPAAddMan<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AuditRPAAddMan`, params);
    },
    // 获取需求驳回数量
    getAuditRejectNum<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetAuditRejectNum`, params);
    },
    //导入需求
    importRequires<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/ImportRequires`, params);
    },
    //更新需求退役
    updateRequiresRetire<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewRequire/UpdateRequiresRetire`,
            params
        );
    },
    //估算FP
    estimateFP<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/EstimateFP`, params);
    },
    //获取估算FP列表
    getEstimateFPList<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/GetEstimateFPList`, params);
    },
    // 添加FP估算
    addFPEstimate<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/AddFPEstimate`, params);
    },
    // 删除FP估算
    delFPEstimate<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/DelFPEstimate`, params);
    },
    // 更新FP估算
    updateFPEstimate<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/UpdateFPEstimate`, params);
    },
    //下载导入模板
    downloadFPTemplate<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/DownloadFPTemplate`, params);
    },
    // 更新FPcount
    updateFPCount<T>(params: FormData) {
        return services.post(`${base.lk}/NewRequire/UpdateFPCount`, params);
    },
};

export default newRequireManageAPI;
